import React from 'react'
import Manager from '../../public/components/Manager'
import ForgetSwipeCardApplyDetail from './ForgetSwipeCardApplyDetail'
import { doForgetSwipeCardApplyAction } from '../../business/ForgetSwipeCardApplyAction'
Ext.require('Ext.Toast')

const config = props => {
	return {
		tabs: {
			'申请中': {
				buttons: [
					{ text: '申请...', handler: ({ showDetail, refreshPage }) => showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={0} />) },
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, flex: 1, },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1, },
					{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
					{ _date: '忘刷卡日期', field: 'SupplementDate', minWidth: 150, filter: true, align: 'left', flex: 1 },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.id} />)
				}
			},
			'驳回申请': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, flex: 1, },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1, },
					{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
					{ _date: '忘刷卡日期', field: 'SupplementDate', minWidth: 150, filter: true, align: 'left', flex: 1 },
					{ _: 'taskName', field: '_TaskName' }
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.id} taskName={data.taskName} />)
				}
			},
			'签核中': {
				buttons: [
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, flex: 1, },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1, },
					{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
					{ _date: '忘刷卡日期', field: 'SupplementDate', minWidth: 150, filter: true, align: 'left', flex: 1 },
					{ _text: '当前操作人', minWidth: 150, search: true, flex: 1 },
					{ _: '状态名称' },
					// {
					//     _button: '驳回申请', icon: 'reply', ui: 'action decline alt', minWidth: 150, handler: ({ showDetail, refreshPage }, data) => {
					//         doForgetSwipeCardApplyAction(props.dispatch, '驳回申请', { id: data.id, action: `${data.状态名称}.退回申请`, onSave: refreshPage, showDetail: showDetail })
					//     }
					// },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.id} readOnly={true} />)
				}
			},
			'已完成':
			{
				buttons: [
				],
				columns: [
					{ _text: '申请编号', field: 'Number', minWidth: 250, search: true, flex: 1, },
					{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, flex: 1, },
					{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left', flex: 1 },
					{ _date: '忘刷卡日期', field: 'SupplementDate', minWidth: 150, filter: true, align: 'left', flex: 1 },
				],
				onDoubleTap: ({ showDetail, refreshPage }, data) => {
					showDetail(props => <ForgetSwipeCardApplyDetail {...props} id={data.id} />)
				}
			}
		}
	}
}

export default props => <Manager {...props} config={config} />